// extracted by mini-css-extract-plugin
export default {"operatorsSection":"UwESvtm2D0_Z2TdFbPCn","investorsSection":"i4EEIXeRp7tOvcDKUkBe","emergingSection":"wBcdo6vUDejfXmlj9fUu"};